var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "basic-information" },
    [
      _c("fieldset", { staticClass: "info-group" }, [
        _c("legend", [_vm._v(_vm._s(_vm.$t("kyc.section.basicInformation")))]),
      ]),
      _c(
        "fieldset",
        { attrs: { disabled: _vm.kycStatus === "submitted" ? true : false } },
        [
          _c("div", { staticClass: "info-group" }, [
            _c(
              "div",
              {
                staticClass: "form-group with-icon-right",
                class: {
                  "has-error": _vm.errors.has("companyName"),
                  valid: _vm.isFormFieldValid("companyName"),
                },
              },
              [
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.basicInformation.companyName,
                        expression: "basicInformation.companyName",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: {
                      id: "companyNameInput",
                      name: "companyName",
                      "data-vv-as": "Company Name",
                      maxlength: "128",
                      autocomplete: "off",
                      required: "",
                    },
                    domProps: { value: _vm.basicInformation.companyName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.basicInformation,
                          "companyName",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _c("i", {
                    staticClass:
                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                  }),
                  _c("i", {
                    staticClass: "fa fa-check valid-icon icon-right input-icon",
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "control-label",
                      attrs: { for: "companyName" },
                    },
                    [_vm._v("Company Name：")]
                  ),
                  _c("i", { staticClass: "bar" }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("companyName"),
                          expression: "errors.has('companyName')",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("companyName")))]
                  ),
                ]),
              ]
            ),
            _c("div", { staticClass: "info-group-space" }),
            _c(
              "div",
              {
                staticClass: "form-group with-icon-right",
                class: {
                  "has-error": _vm.errors.has("registrationNumber"),
                  valid: _vm.isFormFieldValid("registrationNumber"),
                },
              },
              [
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.basicInformation.registrationNumber,
                        expression: "basicInformation.registrationNumber",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: {
                      id: "registrationNumberInput",
                      name: "registrationNumber",
                      "data-vv-as": "Registration Number",
                      maxlength: "128",
                      autocomplete: "off",
                      required: "",
                    },
                    domProps: {
                      value: _vm.basicInformation.registrationNumber,
                    },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.basicInformation,
                          "registrationNumber",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _c("i", {
                    staticClass:
                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                  }),
                  _c("i", {
                    staticClass: "fa fa-check valid-icon icon-right input-icon",
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "control-label",
                      attrs: { for: "registrationNumber" },
                    },
                    [_vm._v("Registration Number：")]
                  ),
                  _c("i", { staticClass: "bar" }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("registrationNumber"),
                          expression: "errors.has('registrationNumber')",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("registrationNumber")))]
                  ),
                ]),
              ]
            ),
          ]),
          _c("div", { staticClass: "info-group" }, [
            _c(
              "div",
              {
                staticClass: "form-group with-icon-right",
                class: {
                  "has-error": _vm.errors.has("incorporationDate"),
                  valid: _vm.isFormFieldValid("incorporationDate"),
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("vuestic-date-picker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        id: "incorporationDateInput",
                        name: "incorporationDate",
                        "data-vv-as": "Incorporation Date",
                        required: "",
                      },
                      model: {
                        value: _vm.basicInformation.incorporationDate,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.basicInformation,
                            "incorporationDate",
                            $$v
                          )
                        },
                        expression: "basicInformation.incorporationDate",
                      },
                    }),
                    _c("i", {
                      staticClass:
                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                    }),
                    _c("i", {
                      staticClass:
                        "fa fa-check valid-icon icon-right input-icon",
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "incorporationDate" },
                      },
                      [_vm._v("Incorporation Date：")]
                    ),
                    _c("i", { staticClass: "bar" }),
                    _c(
                      "small",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("incorporationDate"),
                            expression: "errors.has('incorporationDate')",
                          },
                        ],
                        staticClass: "help text-danger",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("incorporationDate")))]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c("div", { staticClass: "info-group-space" }),
            _c(
              "div",
              {
                staticClass: "form-group with-icon-right",
                class: {
                  "has-error": _vm.countryStatus,
                  valid: _vm.countryStatus,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("vuestic-kyc-select", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      ref: "regionInput",
                      attrs: {
                        id: "registeredCountryorRegionInput",
                        name: "registeredCountryOrRegion",
                        "data-vv-as": "Registered Country or Region",
                        required: "",
                        label: _vm.$t("kyc.registeredCountryOrRegion") + "：",
                        "option-key": "value",
                        options: _vm.CountriesList,
                        disabled: _vm.kycStatus === "submitted" ? true : false,
                        clearable: "",
                      },
                      on: { input: _vm.regionForbiddenInput },
                      model: {
                        value: _vm.basicInformation.registeredCountryOrRegion,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.basicInformation,
                            "registeredCountryOrRegion",
                            $$v
                          )
                        },
                        expression:
                          "basicInformation.registeredCountryOrRegion",
                      },
                    }),
                    _c("i", {
                      staticClass:
                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                    }),
                    _c("i", { staticClass: "fa icon-right input-icon" }),
                    _c(
                      "small",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.countryStatus,
                            expression: "countryStatus",
                          },
                        ],
                        staticClass: "help text-danger",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.errors.first("registeredCountryOrRegion"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _c("div", { staticClass: "info-group" }, [
            _c(
              "div",
              {
                staticClass: "form-group with-icon-right",
                class: {
                  "has-error": _vm.errors.has("registeredAddress"),
                  valid: _vm.isFormFieldValid("registeredAddress"),
                },
              },
              [
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.basicInformation.registeredAddress,
                        expression: "basicInformation.registeredAddress",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: {
                      id: "registeredAddressInput",
                      name: "registeredAddress",
                      "data-vv-as": "Registered Address",
                      maxlength: "128",
                      autocomplete: "off",
                      required: "",
                    },
                    domProps: { value: _vm.basicInformation.registeredAddress },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.basicInformation,
                          "registeredAddress",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _c("i", {
                    staticClass:
                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                  }),
                  _c("i", {
                    staticClass: "fa fa-check valid-icon icon-right input-icon",
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "control-label",
                      attrs: { for: "registeredAddress" },
                    },
                    [_vm._v("Registered Address：")]
                  ),
                  _c("i", { staticClass: "bar" }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("registeredAddress"),
                          expression: "errors.has('registeredAddress')",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("registeredAddress")))]
                  ),
                ]),
              ]
            ),
            _c("div", { staticClass: "info-group-space" }),
            _c(
              "div",
              {
                staticClass: "form-group with-icon-right",
                class: {
                  "has-error": _vm.errors.has("correspondenceAddress"),
                  valid: _vm.isFormFieldValid("correspondenceAddress"),
                },
              },
              [
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.basicInformation.correspondenceAddress,
                        expression: "basicInformation.correspondenceAddress",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: {
                      id: "correspondenceAddressInput",
                      name: "correspondenceAddress",
                      "data-vv-as": "Correspondence Address",
                      maxlength: "128",
                      autocomplete: "off",
                      required: "",
                    },
                    domProps: {
                      value: _vm.basicInformation.correspondenceAddress,
                    },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.basicInformation,
                          "correspondenceAddress",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _c("i", {
                    staticClass:
                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                  }),
                  _c("i", {
                    staticClass: "fa fa-check valid-icon icon-right input-icon",
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "control-label",
                      attrs: { for: "correspondenceAddress" },
                    },
                    [_vm._v("Correspondence Address：")]
                  ),
                  _c("i", { staticClass: "bar" }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("correspondenceAddress"),
                          expression: "errors.has('correspondenceAddress')",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("correspondenceAddress")))]
                  ),
                ]),
              ]
            ),
          ]),
          _c("div", { staticClass: "info-group" }, [
            _c(
              "div",
              {
                staticClass: "form-group with-icon-right",
                class: { "has-error": _vm.typeStatus, valid: _vm.typeStatus },
              },
              [
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("vuestic-kyc-select", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      ref: "companyTypeInput",
                      attrs: {
                        name: "companyType",
                        "data-vv-as": "Company Type",
                        required: "",
                        label: _vm.$t("kyc.companyType") + "：",
                        "option-key": "value",
                        options: _vm.CompanyTypes,
                        disabled: _vm.kycStatus === "submitted" ? true : false,
                      },
                      on: { input: _vm.companyTypeForbiddenInput },
                      model: {
                        value: _vm.basicInformation.companyType,
                        callback: function ($$v) {
                          _vm.$set(_vm.basicInformation, "companyType", $$v)
                        },
                        expression: "basicInformation.companyType",
                      },
                    }),
                    _c("i", {
                      staticClass:
                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                    }),
                    _c("i", { staticClass: "fa icon-right input-icon" }),
                    _c(
                      "small",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.typeStatus,
                            expression: "typeStatus",
                          },
                        ],
                        staticClass: "help text-danger",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("companyType")))]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c("div", { staticClass: "info-group-space" }),
            _c(
              "div",
              {
                staticClass: "form-group with-icon-right",
                class: {
                  "has-error": _vm.errors.has("contactPhone"),
                  valid: _vm.isFormFieldValid("contactPhone"),
                },
              },
              [
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.basicInformation.contactPhone,
                        expression: "basicInformation.contactPhone",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: {
                      id: "contactPhoneInput",
                      name: "contactPhone",
                      "data-vv-as": "Contact Phone",
                      maxlength: "128",
                      autocomplete: "off",
                      required: "",
                    },
                    domProps: { value: _vm.basicInformation.contactPhone },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.basicInformation,
                          "contactPhone",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _c("i", {
                    staticClass:
                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                  }),
                  _c("i", {
                    staticClass: "fa fa-check valid-icon icon-right input-icon",
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "control-label",
                      attrs: { for: "contactPhone" },
                    },
                    [_vm._v("Contact Phone：")]
                  ),
                  _c("i", { staticClass: "bar" }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("contactPhone"),
                          expression: "errors.has('contactPhone')",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("contactPhone")))]
                  ),
                ]),
              ]
            ),
          ]),
          _vm.kycStatus === "firstEdit"
            ? _c("div", { staticClass: "info-group" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group with-icon-right",
                    class: {
                      "has-error": _vm.errors.has("contactEmail"),
                      valid: _vm.isFormFieldValid("contactEmail"),
                    },
                  },
                  [
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.basicInformation.contactEmail,
                            expression: "basicInformation.contactEmail",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'",
                          },
                        ],
                        attrs: {
                          id: "contactEmailInput",
                          name: "contactEmail",
                          "data-vv-as": "Contact Email",
                          maxlength: "128",
                          autocomplete: "off",
                          required: "",
                        },
                        domProps: { value: _vm.basicInformation.contactEmail },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.basicInformation,
                              "contactEmail",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _c("i", {
                        staticClass:
                          "fa fa-exclamation-triangle error-icon icon-right input-icon",
                      }),
                      _c("i", {
                        staticClass:
                          "fa fa-check valid-icon icon-right input-icon",
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "contactEmail" },
                        },
                        [_vm._v("Contact Email：")]
                      ),
                      _c("i", { staticClass: "bar" }),
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("contactEmail"),
                              expression: "errors.has('contactEmail')",
                            },
                          ],
                          staticClass: "help text-danger",
                        },
                        [_vm._v(_vm._s(_vm.errors.first("contactEmail")))]
                      ),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "info-group-space" }),
                _c(
                  "div",
                  {
                    staticClass: "form-group with-icon-right",
                    class: {
                      "has-error": _vm.errors.has("emailVerifyCode"),
                      valid: _vm.isFormFieldValid("emailVerifyCode"),
                    },
                  },
                  [
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.basicInformation.emailVerifyCode,
                            expression: "basicInformation.emailVerifyCode",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|verifyCode",
                            expression: "'required|verifyCode'",
                          },
                        ],
                        attrs: {
                          id: "verficationCodeInput",
                          name: "emailVerifyCode",
                          "data-vv-as": "E-mail Verfication Code",
                          maxlength: "6",
                          autocomplete: "off",
                          required: "",
                        },
                        domProps: {
                          value: _vm.basicInformation.emailVerifyCode,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.basicInformation,
                              "emailVerifyCode",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _c("i", {
                        staticClass:
                          "fa fa-exclamation-triangle error-icon icon-right input-icon",
                      }),
                      _c("i", {
                        staticClass:
                          "fa fa-check valid-icon icon-right input-icon",
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "emailVerifyCode" },
                        },
                        [_vm._v("E-mail Verfication Code：")]
                      ),
                      _c("i", { staticClass: "bar" }),
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("emailVerifyCode"),
                              expression: "errors.has('emailVerifyCode')",
                            },
                          ],
                          staticClass: "help text-danger",
                        },
                        [_vm._v(_vm._s(_vm.errors.first("emailVerifyCode")))]
                      ),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary btn-micro btn-send send-email",
                        attrs: { disabled: _vm.sendEmailDisabled },
                        on: { click: _vm.sendEmail },
                      },
                      [_vm._v(_vm._s(_vm.sendEmailText))]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.kycStatus === "saved" || _vm.kycStatus === "submitted"
            ? _c("div", { staticClass: "info-group" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group with-icon-right",
                    class: {
                      "has-error": _vm.errors.has("contactEmail"),
                      valid: _vm.isFormFieldValid("contactEmail"),
                    },
                  },
                  [
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.basicInformation.contactEmail,
                            expression: "basicInformation.contactEmail",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'",
                          },
                        ],
                        attrs: {
                          id: "contactEmailInput",
                          name: "contactEmail",
                          "data-vv-as": "Contact Email",
                          maxlength: "128",
                          autocomplete: "off",
                          required: "",
                          disabled: "",
                        },
                        domProps: { value: _vm.basicInformation.contactEmail },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.basicInformation,
                              "contactEmail",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _c("i", {
                        staticClass:
                          "fa fa-exclamation-triangle error-icon icon-right input-icon",
                      }),
                      _c("i", {
                        staticClass:
                          "fa fa-check valid-icon icon-right input-icon",
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "contactEmail" },
                        },
                        [_vm._v("Contact Email：")]
                      ),
                      _c("i", { staticClass: "bar" }),
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("contactEmail"),
                              expression: "errors.has('contactEmail')",
                            },
                          ],
                          staticClass: "help text-danger",
                        },
                        [_vm._v(_vm._s(_vm.errors.first("contactEmail")))]
                      ),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-micro btn-send",
                        attrs: { disabled: _vm.kycStatus === "submitted" },
                        on: { click: _vm.changeEmail },
                      },
                      [_vm._v(_vm._s(_vm.$t("kyc.change")))]
                    ),
                  ]
                ),
                _c("div", { staticClass: "info-group-space" }),
                _c("div", { staticClass: "form-group with-icon-right" }),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "vuestic-modal",
        {
          ref: "changeEmail",
          staticClass: "change-email-show",
          staticStyle: { height: "100%", width: "60vw" },
          attrs: {
            show: _vm.changeEmailShow,
            okText: _vm._f("translate")("modal.confirm2"),
            okClass: "btn btn-primary btn-micro",
            cancelClass: "btn btn-secondary btn-micro",
            cancelText: _vm._f("translate")("modal.cancel2"),
            alignModal: "",
          },
          on: {
            "update:show": function ($event) {
              _vm.changeEmailShow = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("kyc.changeEmail"))),
          ]),
          _c("div", [
            _c("form", [
              _c("div", { staticClass: "va-row" }, [
                _c("div", { staticClass: "flex xs12 md12" }, [
                  _c("fieldset", [
                    _c(
                      "div",
                      {
                        staticClass: "form-group with-icon-right",
                        class: {
                          "has-error": _vm.errors.has("changeContactEmail"),
                          valid: _vm.isFormFieldValid("changeContactEmail"),
                        },
                      },
                      [
                        _c("div", { staticClass: "input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.changeEmailBean.changeContactEmail,
                                expression:
                                  "changeEmailBean.changeContactEmail",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|email",
                                expression: "'required|email'",
                              },
                            ],
                            attrs: {
                              name: "changeContactEmail",
                              "data-vv-as": "Contact Email",
                              autocomplete: "off",
                              required: "",
                            },
                            domProps: {
                              value: _vm.changeEmailBean.changeContactEmail,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.changeEmailBean,
                                  "changeContactEmail",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-check valid-icon icon-right input-icon",
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "changeContactEmail" },
                            },
                            [_vm._v("Contact Email：")]
                          ),
                          _c("i", { staticClass: "bar" }),
                          _c(
                            "small",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("changeContactEmail"),
                                  expression:
                                    "errors.has('changeContactEmail')",
                                },
                              ],
                              staticClass: "help text-danger",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.errors.first("changeContactEmail"))
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "form-group with-icon-right",
                        class: {
                          "has-error": _vm.errors.has("changeVerficationCode"),
                          valid: _vm.isFormFieldValid("changeVerficationCode"),
                        },
                      },
                      [
                        _c("div", { staticClass: "input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.changeEmailBean.changeVerficationCode,
                                expression:
                                  "changeEmailBean.changeVerficationCode",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|verifyCode2",
                                expression: "'required|verifyCode2'",
                              },
                            ],
                            attrs: {
                              name: "changeVerficationCode",
                              "data-vv-as": "E-mail Verfication Code",
                              maxlength: "6",
                              autocomplete: "off",
                              required: "",
                            },
                            domProps: {
                              value: _vm.changeEmailBean.changeVerficationCode,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.changeEmailBean,
                                  "changeVerficationCode",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-check valid-icon icon-right input-icon",
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "changeVerficationCode" },
                            },
                            [_vm._v("E-mail Verfication Code：")]
                          ),
                          _c("i", { staticClass: "bar" }),
                          _c(
                            "small",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has(
                                    "changeVerficationCode"
                                  ),
                                  expression:
                                    "errors.has('changeVerficationCode')",
                                },
                              ],
                              staticClass: "help text-danger",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("changeVerficationCode")
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary btn-micro btn-send send-email",
                            attrs: { disabled: _vm.sendChangeEmailDisabled },
                            on: { click: _vm.changeSend },
                          },
                          [_vm._v(_vm._s(_vm.sendChangeEmailText))]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }